module.exports = __webpack_public_path__ + "img/color4_on.c358287a.png";